import Request from '@/api/request';

/**
 * @description: user login api
 */

export const getArticles = async (params, start = 0, limit = 100) => {
  const requestParams = {
    ...params,
    filter: {
      ...params.filter,
      status: 100
    },
    sort: {
      'id' : -1,
    },
    pagination: {
      'start' : start,
      'limit' : limit,
    }
  };
  return await Request.get('/v1/articles', requestParams).then((res) => {
    return res;
  });
};

export const getArticle = async (id) => {
  let params = {};
  return await Request.get('/v1/articles/' + id, params).then((res) => {
    return res;
  });
};

export const putArticle = async (id, params) => {
  return await Request.put('/v1/articles/'+id, params).then((res) => {
      return res;
  });
}

export const postArticle = async (file, params) => {
  return await Request.fileformpost('/v1/articles', 'filecover', file, params).then((res) => {
    return res;
  });
}

export const postArticleCover = async (articleid, filecover) => {
  let uri = '/v1/articles/'+articleid+'/cover';
  return await Request.fileformpost(uri, 'filecover', filecover).then((res) => {
      return res;
  });
}

export const putArticleOffline = async (id) => {
  return await Request.put('/v1/articles/'+id + '/offline', {}).then((res) => {
      return res;
  });
}

export const putArticleOnline = async (id) => {
  return await Request.put('/v1/articles/'+id + '/online', {}).then((res) => {
      return res;
  });
}


export const getEventArticles = async (eventid, params) => {
  return await Request.get('/v1/events/'+eventid+'/articles', params).then((res) => {
    return res;
  });
};

export const postEventArticle = async (eventid, articleid, params) => {
  return await Request.formpost('/v1/events/'+eventid+'/articles/from/'+articleid, params).then((res) => {
      return res;
  });
};

export const putEventArticle = async (eventid, id, params) => {
  return await Request.put('/v1/events/'+eventid+'/articles/'+id, params).then((res) => {
      return res;
  });
}

export const postEventArticleCover = async (eventid, filecover, params) => {
  const articleid = params.articleid;
  let uri = '/v1/events/'+eventid+'/articles/'+articleid+'/cover';
  return await Request.fileformpost(uri, 'filecover', filecover).then((res) => {
      return res;
  });
}

export const putArticleRichText = async (articleid, params) => {
  params.type = 0;
  return await Request.put('/v1/articles/'+articleid+'/richtext', params).then((res) => {
    return res;
  });  
};

export const getArticleRichText = async (articleid) => {
  return await Request.get('/v1/articles/'+articleid+'/richtext',{type:0}).then((res) => {
    return res;
  });  
};